import Vue from 'vue';

let errorHandler = (e: any, msg?: string) => {
    if (e && e.type === 'ignore') {
        console.log('ignore error', msg);
        return false;
    } else if (msg) {
        Vue.prototype.$message.error(`${msg}:${JSON.stringify(e)}`);
        return false;
    }
    return true;
};

export default errorHandler;
